import { render } from "./LbrxLoginLogo.vue?vue&type=template&id=6f161c9c&scoped=true"
import script from "./LbrxLoginLogo.vue?vue&type=script&lang=js"
export * from "./LbrxLoginLogo.vue?vue&type=script&lang=js"

import "./LbrxLoginLogo.vue?vue&type=style&index=0&id=6f161c9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f161c9c"]])

export default __exports__